export default __webpack_public_path__ + "static/media/Stats.b3ad8a8a.png";